import { useNavigate, useParams } from 'react-router';

import { TagDetails } from '../TagDetails/TagDetails';
import { Loading, Modal, Section } from '../../shared';
import { LanguageType } from '@lifeserver/shared';

import { useDeleteTag, useTag, useUpdateTag } from '../../hooks/tags';

import { handleError } from '../../utils/utils.ts';

import { RouteTo } from '../../routes';

import { CreateOrUpdateTag } from '../../types/tagTypes';

type TagProps = { language: LanguageType };

export const TagUpdatePage = (props: TagProps) => {
    const navigate = useNavigate();
    const params = useParams();
    const tagId = params.id as string;

    const {
        tag: fetchedTag,
        errorMessage: fetchTagError,
        isLoading: isFetchTagLoading,
    } = useTag(tagId);
    const {
        updatedTag,
        isLoading: isUpdateTagLoading,
        updateTag,
    } = useUpdateTag(tagId);
    const { deleteTag: deleteTagMutation } = useDeleteTag();

    async function onSave(tag: CreateOrUpdateTag) {
        try {
            await updateTag(tag);
            return true;
        } catch {
            return false;
        }
    }

    const handleDeleteTag = async () => {
        const isConfirmed = await Modal.confirm({
            heading: 'Delete tag',
            text: 'Really delete this tag?',
            okLabel: 'Yes do it!',
        });

        if (!isConfirmed) return;

        try {
            await deleteTagMutation(Number(tagId));
            navigate(RouteTo.Tags());
        } catch (error) {
            handleError('Error deleting tag', error);
        }
    };

    if (isFetchTagLoading) {
        return <Loading />;
    }

    if (fetchTagError || !fetchedTag) {
        return <Section>{fetchTagError ?? 'The tag does not exist'}</Section>;
    }

    return (
        <TagDetails
            language={props.language}
            isNew={false}
            onSave={onSave}
            isSaving={isUpdateTagLoading}
            initialTag={updatedTag ?? fetchedTag}
            onDelete={handleDeleteTag}
        />
    );
};
